
const addHistoricalDataToHeatmap = (data, historicalData) => {
  const {batchInsightsReporting = []} = data
  const {teamDriverAverageList: {results = [], ...meta} = {}} = data

  const {batchInsightsReporting: hBatchInsightsReporting = []} = historicalData
  const {teamDriverAverageList: {results: hResults = []} = {}} = historicalData

  const headerData = batchInsightsReporting.map((item) => {
    const {answersAverage: historicalAnswersAverage} = hBatchInsightsReporting
      .find(({params: {driverId}}) => driverId === item.params.driverId) || {}

    return {...item, historicalAnswersAverage}
  })

  const newResults = results.map((item) => {
    const comparisonItem = hResults.find((i) => {
      return item.driverId === i.driverId && item.teamId === i.teamId
    }) || {}
    return {...item, historicalAverageScore: comparisonItem.averageScore}
  })
  return {headerData, data: {results: newResults, ...meta}}
}

export default addHistoricalDataToHeatmap
